import { capitalDesignTokens, createTypedSxStyles } from "@opengov/capital-mui-theme";

const { semanticColors, foundations } = capitalDesignTokens;

export const styles = createTypedSxStyles({
  container: {
    display: "flex",
    flex: 1,
    padding: "24px",
    background: semanticColors.background.secondary,
  },
  toggleChildView: {
    marginLeft: "24px",
  },
  selectedStory: {
    display: "flex",
    backgroundColor: "white",
    padding: "12px",
    width: "fit-content",
    maxWidth: "576px",
    border: "1px solid #c4c4c4",
    boxShadow: "0 1px 3px rgba(0,0,0,0.12)",
    borderRadius: "4px",
    alignItems: "center",
    margin: "8px 0",
  },
  storyTitle: {
    marginLeft: "8px",
  },
  fullWidth: {
    display: "flex",
    flex: 1,
    flexDirection: "column",
    overflow: "hidden",
  },
  navBarTitle: {
    fontSize: "18px",
    fontWeight: foundations.typography.fontWeight.normal,
    color: "black",
  },
  navBarHeader: {
    display: "flex",
    flexDirection: "column",
  },
  navBarCheckbox: {
    display: "flex",
    alignItems: "center",
    marginLeft: "0",
    marginTop: "8px",
    color: semanticColors.foreground.primary,
    width: "fit-content",
  },
  content: {
    display: "flex",
    flex: 1,
    flexDirection: "row",
    overflow: "hidden",
  },
  leftContent: {
    display: "flex",
    marginTop: "24px",
    flex: 1,
    maxWidth: "280px",
    overflow: "hidden",
  },
  rightContent: {
    marginTop: "24px",
    display: "flex",
    flex: 1,
    width: "100%",
    overflow: "hidden",
  },
  reorderableList: {
    display: "flex",
    flexDirection: "column",
    paddingBottom: "16px",
    paddingRight: "8px",
    width: "280px",
  },
  filterRootSectionHeader: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: "8px",
  },
  flexRow: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "8px",
  },
  folderIcon: {
    fill: semanticColors.foreground.secondary,
  },
  foldersHeader: {
    paddingLeft: "8px",
    fontWeight: foundations.typography.fontWeight.medium,
    fontSize: "14px",
    color: semanticColors.foreground.secondary,
  },
  buttons: {
    display: "flex",
    gap: "8px",
  },
  reorderableListView: {
    overflow: "scroll",
    "& [class*=\"container_\"]": {
      backgroundColor: "transparent",
    },
  },
  contentHeader: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
  },
  description: {
    display: "flex",
    flexDirection: "column",
    backgroundColor: "#f5f5f5",
    width: "100%",
    padding: "16px",
    margin: "16px 0",
  },
  organizeStoriesText: {
    letterSpacing: "0.58px",
    fontWeight: foundations.typography.fontWeight.medium,
    fontSize: "12px",
  },
  organizeStoriesDescText: {
    fontWeight: foundations.typography.fontWeight.normal,
    fontSize: "12px",
  },
  rightContentContainer: {
    width: "inherit",
    marginLeft: "24px",
    display: "flex",
    flexDirection: "column",
    overflow: "scroll",
  },
  storiesReorderableItemButton: {
    padding: 0,
  },
  storiesItemButtons: {
    display: "flex",
    gap: "16px",
    marginRight: "8px",
  },
  storiesItemContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "16px",
  },
  storiesItemLabel: {
    display: "flex",
    flexDirection: "column",
  },
  centered: {
    display: "flex",
    flex: 1,
    alignItems: "center",
    justifyContent: "center",
  },
  outlineIcon: {
    fill: semanticColors.foreground.primary,
  },
  iconContainer: {
    cursor: "default",
    display: "flex",
    alignItems: "center",
    width: "14px",
  },
  navBarDesc: {
    color: semanticColors.foreground.secondary,
  },
});
